interface Replacements {
  [name: string]: string | null | undefined;
}

/**
 * It replaces placeholders in a URL with values from a dictionary
 * @param {string} urlWithPlaceholders - The URL with placeholders in it.
 * @param {Replacements | null | undefined} replacements - Replacements object with keyof placeholders in urlWithPlaceholders | null | undefined = undefined
 * @returns A function that takes a url and replacements and returns a url with assigned replacement value instead of placeholders if replacements are not empty or undefined or url does not contain placeholders.
 */
export const replacePlaceholdersInUrl = (
  urlWithPlaceholders: string,
  replacements: Replacements | null | undefined = undefined,
): string | null => {
  const numberOfPlaceholdersToReplace = urlWithPlaceholders.match(/{(\w+)}/g);
  if (!numberOfPlaceholdersToReplace) {
    return null;
  }
  if (
    replacements &&
    Object.values(replacements).some((replacementValue) => replacementValue === null || replacementValue === '')
  ) {
    return null;
  }
  if (
    replacements &&
    Object.keys(replacements).length > 0 &&
    Object.keys(replacements).length >= numberOfPlaceholdersToReplace.length
  ) {
    return urlWithPlaceholders.replace(
      /{(\w+)}/g,
      (fullMatch, group1: keyof Replacements) => replacements[group1] ?? fullMatch,
    );
  }

  return null;
};
